// extracted by mini-css-extract-plugin
export default {"cardImage":"FFaf3G"};